import { formatCurrency } from '../../../utils/baseUtils';

// A reward in dollars: whole amounts without cents ($1,000), the rest with
// them ($1,000.50). formatCurrency's own maximumFractionDigits option rounds
// the cents away, so the choice is made here, on the value.
export const formatReward = (value) => {
  const number = Number(value);
  const whole = !Number.isFinite(number) || Math.round(Math.abs(number) * 100) % 100 === 0;
  return whole ? formatCurrency(number, { maximumFractionDigits: 0 }) : formatCurrency(number);
};

// "1 day" / "3 days"; a missing count reads as 0.
export const pluralize = (count, singular, plural = `${singular}s`) => {
  const n = Number(count) || 0;
  return `${n} ${n === 1 ? singular : plural}`;
};

// The link field shows the head (host and path) and a tail that never
// shrinks, so a long link keeps its end visible: the tail starts at `?ref=`,
// or at the last path segment when there is no `?ref=`. A link with nothing
// to split (a bare code, a bare host) is all head.
export const splitReferralLink = (link) => {
  const text = typeof link === 'string' ? link : '';
  let at = text.indexOf('?ref=');
  if (at < 0) {
    const slash = text.lastIndexOf('/');
    // A slash that is half of "://" is not a path segment.
    at = slash > 0 && text[slash - 1] !== '/' && slash < text.length - 1 ? slash : -1;
  }
  return at > 0 ? { head: text.slice(0, at), tail: text.slice(at) } : { head: text, tail: '' };
};
